var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-info",
    width: 20.289,
    height: 20,
    viewBox: "0 0 20.289 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-info .a{fill:#e87722;}.icon-info .b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-957.999 -651)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-746.403 -267.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M218.64,239.855a10.858,10.858,0,0,1-9.4,7.057,8.444,8.444,0,0,1-1.17-.01,10.412,10.412,0,0,1-9.028-11.383,8.724,8.724,0,0,1,.331-1.325,10.126,10.126,0,0,1,.552-1.325,12.991,12.991,0,0,1,3.534-3.976c.295-.2.593-.384.9-.561s.612-.341.925-.492c5.349-2.814,11.858,1.281,13.592,6.8a9.685,9.685,0,0,1,.35,1.535,6.584,6.584,0,0,1-.2,2.5A10.323,10.323,0,0,1,218.64,239.855Z",
    transform: "translate(1505.447 691.475)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.45-8.19c-.054,0-.036.072-.072.09A67.241,67.241,0,0,1,.324-.018c.81-.018,1.764,0,2.466,0,0-2.934.18-5.166.27-8.082C2.088-8.19,1.242-8.082.45-8.19Zm1.1-3.564c-.594.108-1.368.612-1.4,1.224A1.758,1.758,0,0,0,1.638-9c.612,0,1.692-.774,1.638-1.44a1.83,1.83,0,0,0-.576-.846A1.4,1.4,0,0,0,1.548-11.754Z",
    transform: "translate(966.857 666.767)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.828c154f0dff850e8512699ca5d9cc4b.svg";
export { ForwardRef as ReactComponent };